import { AccommodationExtraApiDto } from '@lx/shared/api';
import { Amount } from '@lx/shared/data-access/types';
import { Accommodation as AccommodationAPI } from '@lx/shared/data-access/products';

export interface BaseAccommodation {
  code?: string;
  type?: AccommodationType;
}

export interface Accommodation extends BaseAccommodation {
  title?: string;
  image?: string;
  price?: Amount;
  description?: string;
  mealOptions?: string;
  bathroomType?: string;
  roomType?: string;
  galleryUrls?: string[];
  withPromotion?: boolean;
  multiCurrencyPrice?: Amount[];
  groupedItems?: AccommodationAPI[];
}

export type AccommodationType = AccommodationExtraApiDto.TypeEnum;

export const HOMESTAY = AccommodationExtraApiDto.TypeEnum.HOMESTAY;
export const RESIDENCE = AccommodationExtraApiDto.TypeEnum.RESIDENCE;
export const OTHER = AccommodationExtraApiDto.TypeEnum.OTHER;
